import { Group, Progress, Stack, Text } from '@mantine/core';
import { InternalStateChip } from '@/features/staff/InternalStateChip';
import { brand } from '@/theme/theme';

interface Stage {
  name?: string;
  state?: string;
  progress?: number;
}

export function StagesProgress({ stages, progress }: { stages: unknown; progress?: number | null }) {
  const rows = Array.isArray(stages) ? (stages as Stage[]) : [];
  const pct = Math.round(((progress ?? 0) as number) * 100);
  return (
    <Stack gap="xs">
      <Group justify="space-between">
        <Text fz={13} c={brand.textMuted}>
          {pct}{' '}%
        </Text>
      </Group>
      <Progress value={pct} color="forest.6" bg="forest.0" size="md" radius="sm" />
      {rows.length > 0 && (
        <Stack gap={4}>
          {rows.map((s, i) => (
            <Group key={i} gap="sm">
              <InternalStateChip state={s.state ?? ''} />
              <Text fz={13}>{s.name}</Text>
              {typeof s.progress === 'number' && (
                <Text fz={12} c={brand.textMuted}>
                  {Math.round(s.progress * 100)}{' '}%
                </Text>
              )}
            </Group>
          ))}
        </Stack>
      )}
    </Stack>
  );
}
